import store from 'store'
import { sleep } from './sleep'

const increment = store.getActions().datadog.increment

export async function retry<T>(
  fn: () => Promise<T>,
  retriesLeft: number = 3,
  interval: number = 1000,
  exponential: boolean = true
): Promise<T> {
  try {
    const val = await fn()
    return val
  } catch (error) {
    const datadogTags = [`fn:${fn.name || 'anon'}`]
    increment({ name: 'retry.error', value: 1, tags: datadogTags })
    if (retriesLeft) {
      await sleep(interval)
      return retry(fn, retriesLeft - 1, exponential ? interval * 2 : interval, exponential)
    } else {
      increment({ name: 'retry.max_tries', value: 1, tags: datadogTags })

      throw new Error(`Max retries reached for function ${fn.name}`)
    }
  }
}
